import * as React from 'react';
function IconPremiumFilled(props) {
    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconPremiumFilled", ...props },
        React.createElement("path", { d: "M21.953 10l-9.957 11.53-.003-.004L16.005 10h5.948zm-8.059 0l-3.406 9.784L2.04 10h11.854zm3.547-7l4.501 5H10.091l1.741-5h5.61zm-9.46 5h-5.93l4.497-5h3.174L7.981 8z", fill: "currentColor" })));
}
export default IconPremiumFilled;
//# sourceMappingURL=IconPremiumFilled.js.map